var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HelperViewStatus',{staticClass:"order-error",attrs:{"data-testid":"order-error","status":"alert","title":"Houve um problema ao carregar a ordem","description":"Aguarde alguns instantes e tente novamente.","button-label":"Tentar novamente"},on:{"click":_vm.emitOnRetry}})
}
var staticRenderFns = []

export { render, staticRenderFns }